import React from 'react';
import { default as InputType } from 'antd/lib/input';

import { CommonInput } from './CommonInput';
import { CaptionWrapper, CaptionWrapperProps } from './CaptionWrapper';
import { CommonInputProps } from './types';

export type DefaultInputProps = CommonInputProps & CaptionWrapperProps;

export const Input = React.forwardRef<typeof InputType, DefaultInputProps>(
  ({ label, error, caption, wrapperStyle, ...props }, ref) => (
    <CaptionWrapper label={label} error={error} caption={caption} wrapperStyle={wrapperStyle}>
      <CommonInput ref={ref} hasError={Boolean(error)} {...props} />
    </CaptionWrapper>
  ),
);
